import { useGetMenu, queryClient } from '@yuno/dashboard-api-mfe'
import { Cms } from '@yuno/types'
import { useEffect, useState } from 'react'
import { UseQueryResult } from 'react-query'
import { ItemDrawer } from '../../../../types/drawer'
import { useLogout } from '../../../account-menu/hooks'
import i18n from 'i18next'

export const useMenu = () => {
  const { data, isLoading }: UseQueryResult<Cms.Menu, unknown> = useGetMenu()
  const [ready, setReady] = useState(false)
  const [items, setItems] = useState<ItemDrawer[]>()
  const { isNotAuth } = useLogout()

  const lang = queryClient.getQueryData(['fetch-profile'])?.settings?.language

  useEffect(() => {
    isNotAuth(data)
    getMenuByLang(
      data,
      isLoading,
      setItems,
      setReady,
      lang?.toLowerCase() || 'en',
    )

    addEventListener('CHANGE_LANG', (e: CustomEvent) => {
      getMenuByLang(data, isLoading, setItems, setReady, e.detail)
    })

    if (lang) {
      localStorage.setItem('lang', lang.toLowerCase())
      i18n.changeLanguage(lang.toLowerCase()).then(() => {
        const event = new CustomEvent('CHANGE_LANG', {
          detail: lang.toLowerCase(),
        })
        window.dispatchEvent(event)
        setReady(true)
      })
    }
  }, [data, isLoading, lang])

  return { items, ready }
}
function getMenuByLang(
  data: UseQueryResult<Cms.Menu, unknown>,
  isLoading: UseQueryResult<Cms.Menu, unknown>,
  setItems,
  setReady,
  lang = 'en',
) {
  let menu: ItemDrawer[]
  if (data && !isLoading && !data.code) {
    menu = data?.[lang].sort((a, b) => {
      return a.position - b.position
    })
    setItems(menu)

    const paths = menu.map((t) => t.pathname)
    localStorage.setItem('menu', paths.join())
  }
  return menu
}
